import React from 'react'
import MenuIcon from '@material-ui/icons/Menu'
import MoreVert from '@material-ui/icons/MoreVert'
import Horizontal_Logo from '../../assets/images/sselogo1(nobackwhite).png'
import { connect } from 'react-redux'
import { compose } from 'recompose'

const MenuBar = props => {
  const { toggleDrawer } = props

  return (
    <div className="showings-header">
      <MenuIcon className="showings-menu" onClick={() => toggleDrawer()} />
      <img src={Horizontal_Logo} className="showings-logo" alt="logo" />
      <MoreVert
        className="showings-menu"
        alt="MoreVert"
        style={{ visibility: 'hidden' }}
      />
    </div>
  )
}

const mapStateToProps = () => {
  return {}
}

const mapActionsToProps = dispatch => {
  return {
    toggleDrawer: () => dispatch({ type: 'DRAWER_TOGGLED', payload: true })
  }
}

export default compose(
  connect(
    mapStateToProps,
    mapActionsToProps
  )
)(MenuBar)
